import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../services';

@Component({
  selector: 'app-filter-amenities',
  templateUrl: './filter-amenities.component.html',
  styleUrls: ['./filter-amenities.component.scss']
})
export class FilterAmenitiesComponent implements OnInit {

  constructor(public data: DataService,) {

   }
  selected: true
  amenities = this.data.inputs

  ngOnInit(): void {
  }
}
